// TODO:修正前のエンドポイントは必要なくなったら消す

// /master/makers/info
// GET メーカー情報を返す
export const GET_MAKER_LIST_API = '/master/makers';

// /master/cars/info
// GET 車種情報を取得する
export const GET_CAR_LIST_API = '/master/car_names';

// /master/car_models/info
// GET 型式を取得する
export const GET_CAR_MODEL_LIST_API = '/master/car_models';

// /master/parts/info
// GET 部品一覧を返す
export const GET_REQUEST_PARTS_INFO_API = '/master/part_names';

// /master/colors/info
// GET カラー情報を取得する
export const GET_COLORS_API = '/master/colors';
